import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './PackageBooking.css';

const PackageBooking = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const { formData } = location.state || {};
  const [loading, setLoading] = useState(false);

  // if (!formData) {

  //   return (
  //     <div className="package-container">
  //       <h2>Error</h2>
  //       <p>Booking information is missing. Please go back and fill the form again.</p>
  //     </div>
  //   );
  // }

  const plans = [
    // { id: 1, name: 'Acidity/Constipation Correction Cleanse', description: 'A targeted cleanse for digestive health.' },
    // { id: 2, name: 'Gut Cleanse', description: 'Improve gut health with this effective cleanse.' },
    // { id: 3, name: 'Liver Cleanse', description: 'Detox and rejuvenate your liver.' },
    // { id: 4, name: 'Menopause', description: 'Support for managing menopause symptoms.' },
    // { id: 5, name: 'Plateau Breaker Program', description: 'Break through weight-loss plateaus effectively.' },
    { id: 6, name: 'Diabetes Reversal', description: 'A program designed to reverse diabetes naturally.' },
    { id: 7, name: 'PCOS Reversal', description: 'Holistic approach to manage and reverse PCOS.' },
    { id: 8, name: 'Body Transformation', description: 'Transform your body with a personalized plan.' },
    { id: 9, name: 'Lifestyle Management', description: 'Build a sustainable and healthy lifestyle.' },
    { id: 10, name: 'Kid\'s Nutrition', description: 'Specialized program for children’s nutritional needs.' },
  ];

  

  const handlePlanSelection = (planId) => {
    const selectedPlan = plans.find(plan => plan.id === planId);

    if (!selectedPlan) {
      alert('Error: Selected plan not found.');
      return;
    }

    // Redirect based on the plan category
    const isSubscription1 = [1, 2, 3, 4, 5].includes(planId);
    const redirectPath = isSubscription1 ? '/subscription1' : '/subscription2';

    navigate(redirectPath, {
      state: {
         treatment: selectedPlan.name,
      },
    });
  };

  return (
    <div className="package-container">
      <h2>Book Your Package</h2>
      {/* <p>Date: {selectedDate}, Time: {selectedTime}</p> */}
      <div className="plans">
        {plans.map(plan => (
          <div
            key={plan.id}
            className="plan"
            onClick={() => handlePlanSelection(plan.id)}
          >
            <h3>{plan.name}</h3>
            <p>{plan.description}</p>
            <p><strong>{plan.price}</strong></p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PackageBooking;
